import { useMemo } from 'react'
import { useRouter } from 'next/router'

import { Button } from 'components/design-system'
import { ArrowRightIcon } from 'components/design-system/kickoff-icons'
import { LandingPageExperimentAnalytics } from 'components/homepage/experiment/analytics'

import s from './styles.module.css'
import urls from 'utilities/urls'

export const StickyCTA = ({ text }: { text?: string }) => {
  const { query } = useRouter()

  const handleSignUpClick = () => {
    LandingPageExperimentAnalytics.onClick({
      signUpVariant: null,
      location: `Blog Post - Sticky CTA`,
    })
  }

  const href = useMemo(() => {
    return urls.clientSignUp({
      ref: 'blog_freetrial',
      gclid: query.gclid,
      msclkid: query.msclkid,
      utm_campaign_id: query?.utm_campaign_id || null,
      utm_campaign: query?.utm_campaign || 'blog',
      utm_medium: query?.utm_medium || 'blog',
      utm_content: query?.utm_content || null,
    }).href
  }, [
    query.gclid,
    query.msclkid,
    query.utm_campaign,
    query.utm_campaign_id,
    query.utm_content,
    query.utm_medium,
  ])

  return (
    <aside className={s.stickyCtaRoot}>
      <Button
        auto={false}
        iconRight={<ArrowRightIcon />}
        interactive
        onClick={handleSignUpClick}
        to={href}>
        {text}
      </Button>
    </aside>
  )
}
